let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gLXte")).then(() => parcelRequire('5zmQP'));